import { render, staticRenderFns } from "./ReviewMaster.vue?vue&type=template&id=5389d154&scoped=true&"
import script from "./ReviewMaster.vue?vue&type=script&lang=js&"
export * from "./ReviewMaster.vue?vue&type=script&lang=js&"
import style0 from "./ReviewMaster.vue?vue&type=style&index=0&id=5389d154&prod&lang=css&"
import style1 from "./ReviewMaster.vue?vue&type=style&index=1&id=5389d154&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5389d154",
  null
  
)

export default component.exports